export enum TrackerTriggerTypeMobile {
  APP_STATE_CHANGE = 'APP_STATE_CHANGE',
  APP_CALL_END = 'APP_CALL_END',
  APP_CALL_RING = 'APP_CALL_RING',
  APP_CALL_REJECT = 'APP_CALL_REJECT',
  APP_CALL_APPROVE = 'APP_CALL_APPROVE',
  VOIP_CALL_START = 'VOIP_CALL_START',
  VOIP_CALL_END = 'VOIP_CALL_END',
  SCREEN_RECORD_START = 'SCREEN_RECORD_START',
  SCREEN_RECORD_END = 'SCREEN_RECORD_END',
  SCREEN_SHARE_START = 'SCREEN_SHARE_START',
  SCREEN_SHARE_END = 'SCREEN_SHARE_END',
  CUSTOM = 'CUSTOM',
  APPLICATION_OPEN = 'APPLICATION_OPEN',
  NETWORK_CHANGE = 'NETWORK_CHANGE',
  THEME_CHANGE = 'THEME_CHANGE',
  CHARGING_STATE_CHANGE = 'CHARGING_STATE_CHANGE',
  DEBUGGER_ATTACHED = 'DEBUGGER_ATTACHED',
  DEBUGGER_DETACHED = 'DEBUGGER_DETACHED',
  SIM_CARD_CHANGE = 'SIM_CARD_CHANGE',
  TAMPER_DETECTED = 'TAMPER_DETECTED',
  SCREENSHOT_TAKEN = 'SCREENSHOT_TAKEN',
  OVERLAY_DETECTED = 'OVERLAY_DETECTED',
  SDK_VERSION = 'SDK_VERSION',
  TIMESTAMP = 'TIMESTAMP',
  BEHAVIORAL_ANOMALY_DETECTED = 'BEHAVIORAL_ANOMALY_DETECTED',
  BEHAVIORAL_VERIFIED = 'BEHAVIORAL_VERIFIED',
}

export enum TrackerTriggerTypeWeb {
  CUSTOM = 'CUSTOM',
  CLICK = 'CLICK',
  PAGE_VIEW = 'PAGE_VIEW',
  RISK_ALERT = 'RISK_ALERT',
  SDK_VERSION = "SDK_VERSION",
  TIMESTAMP = "TIMESTAMP",
}
